var functionsDef = [];
var functions = [];
var entities = [];
var generalDiscount = [];
var entitiesBonifications = [];
var message = "";

/// <--- % de descuentos --->
/* 
  Nivel: Total Pedido -> lleva % desc. sobre el pedido
  Descripción: DCTO COMERCIAL ADICIONAL EN VALOR PEDIDO - Pie de factura
  Parametros:
      currentPrice: Precio al cual aplicar descuento:
      variant: variante a la cual se le aplicara el descuento.
      parameters= {
          discount: Descuento(1,2..99 o 100), 
          minPrice: Precio minimo para aplicar el descuento
          minDate: Fecha de inicio("31/11/2022"),
          maxDate: Fecha de fin("31/12/2022")
      }
  */
var DCXVPED = function (currentPrice, variant, parameters, cart) {
  var functionName = "DCXVPED";
  var temp = {
    discount: parameters[0].trim(),
    minPrice: parameters[1].trim(),
    cart: cart,
    minDate: parameters[2].trim(),
    maxDate: parameters[3].trim(),
  };

  currentPrice = cart.original_total_price;

  parameters = temp;
  console.log("DCXVPED");
  var result = {
    discountName: "DCXVPED",
    parameters: parameters,
    basePrice: currentPrice,
    priceWithDiscount: currentPrice,
    discount: 0,
    discountPercentage: 0,
    applied: false,
    message: ""
  };

  try {
    if (currentPrice / 100 >= parameters.minPrice) {
      var minDate = moment(parameters.minDate, "DD/MM/YYYY");
      var maxDate = moment(parameters.maxDate, "DD/MM/YYYY");
      var currentDate = moment();

      if (minDate.isSameOrBefore(currentDate) && maxDate.isAfter(currentDate)) {
        var discount = currentPrice * (parameters.discount / 100);
        result.priceWithDiscount = result.basePrice - discount;
        result.discount = discount;
        result.discountPercentage = parameters.discount;
        result.applied = true;
      }
    }
    generalDiscount[functionName + "_" + variant.id] = {
      discountDef: variant.discountDef,
      variant: variant,
      discount: result.discount,
      discountPercentage: result.discountPercentage
    };
  } catch (e) {
    result.message = e.message;
    result.applied = false;
    result.priceWithDiscount = result.basePrice;
  }

  return result;
};
functionsDef.push({ functionName: "DCXVPED", function: DCXVPED });

/* 
  Nivel: Total Pedido -> lleva % desc. sobre el pedido
  Descripción: DCTO COMERCIAL ADICIONAL POR COMPRA PRODUCTO(S) (RANGOS)
  Parametros:
      currentPrice: Precio al cual aplicar descuento:
      variant: variante a la cual se le aplicara el descuento.
      parameters={
          minDate: Fecha de inicio("31/11/2022"),
          maxDate: Fecha de fin("31/12/2022")
          ranges:
          [{
            discount: Descuento(1,2..99 o 100), 
            minPrice: Precio minimo para aplicar el descuento
          }]
      }
  */
var DCXVPEDR = function (currentPrice, variant, parameters, cart) {
  var functionName = "DCXQMAT";
  var temp = {
    ranges: [],
    cart: cart,
    minDate: parameters[0].trim(),
    maxDate: parameters[1].trim(),
  };
  for (var i = 2; i < parameters.length; i++) {
    temp.ranges.push(
      { discount: parameters[i].trim(), minPrice: parameters[++i].trim() }
    );
  }

  parameters = temp;
  var result = {
    discountName: "DCXVPEDR",
    parameters: parameters,
    basePrice: currentPrice,
    priceWithDiscount: currentPrice,
    discount: 0,
    discountPercentage: 0,
    applied: false,
    message: ""
  };

  try {
    currentPrice = cart.original_total_price;

    var minDate = moment(parameters.minDate, "DD/MM/YYYY");
    var maxDate = moment(parameters.maxDate, "DD/MM/YYYY");
    var currentDate = moment();

    if (minDate.isSameOrBefore(currentDate) && maxDate.isAfter(currentDate)) {
      var ranges = parameters.ranges.sort((a, b) => ((a.minPrice) > (b.minPrice)) ? 1 : -1);

      for (i in ranges) {
        var range = ranges[i];

        if (currentPrice / 100 >= range.minPrice) {
          var discount = currentPrice * (range.discount / 100);
          result.priceWithDiscount = result.basePrice - discount;
          result.discount = discount;
          result.discountPercentage = range.discount;
          result.applied = true;

        }
      }

      generalDiscount[functionName + "_" + variant.id] = {
        discountDef: variant.discountDef,
        variant: variant,
        discount: result.discount,
        discountPercentage: result.discountPercentage
      };
    }
  } catch (e) {
    result.message = e.message;
    result.applied = false;
    result.priceWithDiscount = result.basePrice;
    result.general = true;

  }

  return result;
};
functionsDef.push({ functionName: "DCXVPEDR", function: DCXVPEDR });

/* 
  Nivel: SKU x cant -> Lleva % desc sobre ese SKU
  Descripción: DCTO COMERCIAL ADICIONAL POR COMPRA PRODUCTO(S)
  parameters= {
          discount: Descuento(1,2..99 o 100), 
          minQuantity: Cant minima para aplicar el descuento,
          tag: si este campo no esta vacia se busca dentro del carrito los productos que contengan este tag para sumara a la comparación con "minQuantity",
          cart: si tag no es vacio de debe enviar el carrito
          minDate: Fecha de inicio("31/11/2022"),
          maxDate: Fecha de fin("31/12/2022")
      }
  */
var DCXQMAT = function (currentPrice, variant, parameters, cart) {
  var functionName = "DCXQMAT";
  var temp = {
    discount: parameters[0].trim(),
    minQuantity: parameters[1].trim(),
    tag: parameters[2].trim(),
    cart: cart,
    minDate: parameters[3].trim(),
    maxDate: parameters[4].trim(),
  };

  parameters = temp;
  var result = {
    discountName: "DCXQMAT",
    parameters: parameters,
    basePrice: currentPrice,
    priceWithDiscount: currentPrice,
    applied: false,
    message: ""
  };

  try {
    var minDate = moment(parameters.minDate, "DD/MM/YYYY");
    var maxDate = moment(parameters.maxDate, "DD/MM/YYYY");
    var currentDate = moment();
    var changes = [];

    //Limpiar descuentos 100% a items tag x con propiedad bonificacionId = BONXMAT_variantId
    for (i in parameters.cart.items) {
      var item = parameters.cart.items[i];

      if (item.properties && item.properties["_bonificacionId"] == functionName + "_" + variant.id) {
        item.properties["_discount"] = undefined;
        item.properties["_bonificacionId"] = undefined;
        item.properties["_originalPrice"] = undefined;
        item.properties["_quantity"] = undefined;

        changes.push({ 'id': item.key + "", 'quantity': item.quantity, 'properties': item.properties });

        entities[functionName + "_" + item.id] = {
          discountDef: variant.discountDef,
          variant: item,
          discount: 0,
          discountPercentage: 0
        };
      }
    }

    if (minDate.isSameOrBefore(currentDate) && maxDate.isAfter(currentDate)) {
      var tag = parameters.tag;
      var qty = variant.quantity;

      if (tag != null && tag != "") {
        for (i in parameters.cart.items) {
          var item = parameters.cart.items[i];

          if (item.properties["_tags"].includes(tag) && item.id != variant.id) {
            qty += item.quantity;
          }
        }
      }

      if (qty >= parameters.minQuantity) {
        var discount = currentPrice * (parseInt(parameters.discount) / 100);
        result.priceWithDiscount = result.basePrice - discount;
        result.applied = true;

        variant.properties["_discount"] = discount * variant.quantity;
        variant.properties["_bonificacionId"] = functionName + "_" + variant.id;
        variant.properties["_originalPrice"] = variant.price;
        variant.properties["_quantity"] = variant.quantity;

        console.log(variant);
        changes.push({ 'id': variant.key + "", 'quantity': variant.quantity, 'properties': variant.properties });

        entities[functionName + "_" + variant.id] = {
          discountDef: variant.discountDef,
          variant: variant,
          discount: variant.properties["_discount"],
          discountPercentage: variant.properties["_discount"] * 100 / (variant.properties["_originalPrice"] * variant.properties["_quantity"])
        };
      }


    }
  } catch (e) {
    result.message = e.message;
    result.applied = false;
    result.priceWithDiscount = result.basePrice;
  }

  return result;
};
functionsDef.push({ functionName: "DCXQMAT", function: DCXQMAT });

/* 
  Nivel: SKU x cant -> Lleva % desc sobre ese SKU
  Descripción: DCTO COMERCIAL ADICIONAL POR COMPRA PRODUCTO(S) (RANGOS)
  Parametros:
      currentPrice: Precio al cual aplicar descuento:
      variant: variante a la cual se le aplicara el descuento.
      parameters={
          minDate: Fecha de inicio("31/11/2022"),
          maxDate: Fecha de fin("31/12/2022"),
          tag: si este campo no esta vacia se busca dentro del carrito los productos que contengan este tag para sumara a la comparación con "minQuantity",
          cart: si tag no es vacio de debe enviar el carrito,
          ranges:
          [{
            discount: Descuento(1,2..99 o 100), 
            minQuantity: Cant minima para aplicar el descuento,
          }]
      }
  */
var DCXQMATR = function (currentPrice, variant, parameters, cart) {
  var functionName = "DCXQMATR";
  var temp = {
    ranges: [],
    tag: parameters[0].trim(),
    cart: cart,
    minDate: parameters[1].trim(),
    maxDate: parameters[2].trim(),
  };
  var count = 0;
  var top = 2;
  for (var i = 3; i < parameters.length; i++) {
    temp.ranges.push(
      { discount: parameters[i].trim(), minQuantity: parameters[++i].trim() }
    );
  }

  parameters = temp;
  var result = {
    discountName: "DCXQMATR",
    parameters: parameters,
    basePrice: currentPrice,
    priceWithDiscount: currentPrice,
    applied: false,
    message: ""
  };

  try {
    var minDate = moment(parameters.minDate, "DD/MM/YYYY");
    var maxDate = moment(parameters.maxDate, "DD/MM/YYYY");
    var currentDate = moment();
    var changes = [];


    //Limpiar descuentos 100% a items tag x con propiedad bonificacionId = BONXMAT_variantId
    for (i in parameters.cart.items) {
      var item = parameters.cart.items[i];

      if (item.properties && item.properties["_bonificacionId"] == functionName + "_" + variant.id) {
        item.properties["_discount"] = undefined;
        item.properties["_bonificacionId"] = undefined;
        item.properties["_originalPrice"] = undefined;
        item.properties["_quantity"] = undefined;

        changes.push({ 'id': item.key + "", 'quantity': item.quantity, 'properties': item.properties });

        entities[functionName + "_" + item.id] = {
          discountDef: variant.discountDef,
          variant: item,
          discount: 0,
          discountPercentage: 0
        };
      }
    }


    if (minDate.isSameOrBefore(currentDate) && maxDate.isAfter(currentDate)) {
      var tag = parameters.tag;
      var qty = variant.quantity;

      if (tag != null && tag != "") {
        for (i in parameters.cart.items) {
          var item = parameters.cart.items[i];

          if (item.properties["_tags"] != null && item.properties["_tags"].includes(tag) && item.id != variant.id) {
            qty += item.quantity;
          }
        }
      }

      var ranges = parameters.ranges.sort((a, b) => ((a.minQuantity) > (b.minQuantity)) ? 1 : -1);

      for (i in ranges) {
        var range = ranges[i];

        if (qty >= range.minQuantity) {
          var discount = currentPrice * (range.discount / 100);
          result.priceWithDiscount = result.basePrice - discount;
          result.applied = true;
          result.discount = discount;

        }
      }

      if (result.applied) {
        variant.properties["_discount"] = result.discount * variant.quantity;
        variant.properties["_bonificacionId"] = functionName + "_" + variant.id;
        variant.properties["_originalPrice"] = variant.price;
        variant.properties["_quantity"] = variant.quantity;

        console.log(variant);
        changes.push({ 'id': variant.key + "", 'quantity': variant.quantity, 'properties': variant.properties });


        entities[functionName + "_" + variant.id] = {
          discountDef: variant.discountDef,
          variant: variant,
          discount: variant.properties["_discount"],
          discountPercentage: variant.properties["_discount"] * 100 / (variant.properties["_originalPrice"] * variant.properties["_quantity"])
        };
      }
    }
  } catch (e) {
    result.message = e.message;
    result.applied = false;
    result.priceWithDiscount = result.basePrice;
  }

  return result;
};
functionsDef.push({ functionName: "DCXQMATR", function: DCXQMATR });

/// <--- Bonificaciones --->
/* 
  Nivel: SKU x cant -> Lleva 100% de descuento en Y cant de [SKUs]
  Descripción: BONIFICACION PRODUCTOS POR COMPRA PRODUCTOS
  parameters= {
          freeQty: Cantidad de referencias gratis qu tenga "tag" por cada "mulQty", 
          mulQty: Cant multiplo por la cual se dara "freeQty" de ref con "tag",
          tag: se busca dentro del carrito los p,
          minDate: Fecha de inicio("31/11/2022"),
          maxDate: Fecha de fin("31/12/2022")
      }
  */
var BONXMAT = function (currentPrice, variant, parameters, cart) {
  var functionName = "BONXMAT";
  var temp = {
    freeQty: parameters[0].trim(),
    mulQty: parameters[1].trim(),
    tag: parameters[2].trim(),
    cart: cart,
    minDate: parameters[3].trim(),
    maxDate: parameters[4].trim(),
  };

  parameters = temp;

  var result = {
    discountName: "BONXMAT",
    parameters: parameters,
    basePrice: currentPrice,
    priceWithDiscount: currentPrice,
    applied: false,
    message: ""
  };

  try {
    var minDate = moment(parameters.minDate, "DD/MM/YYYY");
    var maxDate = moment(parameters.maxDate, "DD/MM/YYYY");
    var currentDate = moment();
    var changes = [];

    //Limpiar descuentos 100% a items tag x con propiedad bonificacionId = BONXMAT_variantId
    for (i in parameters.cart.items) {
      var item = parameters.cart.items[i];

      if (item.properties && item.properties["_bonificacionId"] == "BONXMAT_" + variant.id) {
        item.properties["_discount"] = undefined;
        item.properties["_bonificacionId"] = undefined;
        item.properties["_originalPrice"] = undefined;
        item.properties["_quantity"] = undefined;

        // changes.push({ 'id': item.key + "", 'quantity': item.quantity, 'properties': item.properties });

        entities[functionName + "_" + item.id] = {
          discountDef: variant.discountDef,
          variant: item,
          discount: 0,
          discountPercentage: 0
        };
      }
    }

    console.log(minDate.isSameOrBefore(currentDate) && maxDate.isAfter(currentDate));

    if (minDate.isSameOrBefore(currentDate) && maxDate.isAfter(currentDate)) {
      if (variant.quantity >= parameters.mulQty) {
        var tag = parameters.tag;

        if (tag != null && tag != "") {
          var totalFree = Math.floor(variant.quantity / parameters.mulQty) * parameters.freeQty;
          var count = 0;

          for (i in parameters.cart.items) {
            var item = parameters.cart.items[i];
            var tagsProp = item.properties["_tags"];

            if (item.properties["_tags"] != null && tagsProp.includes(tag) && item.id != variant.id) {
              item.properties["_discount"] = (totalFree - count) >= item.quantity ? (item.price * item.quantity) : (totalFree - count) * item.price;
              item.properties["_bonificacionId"] = "BONXMAT_" + variant.id;
              item.properties["_originalPrice"] = item.price;
              item.properties["_quantity"] = item.quantity;
              console.log(item)
              // changes.push({ 'id': item.key + "", 'quantity': item.quantity, 'properties': item.properties });
              count += (totalFree - count) >= item.quantity ? item.quantity : (totalFree - count);

              entities[functionName + "_" + item.id] = {
                discountDef: variant.discountDef,
                variant: item,
                discount: item.properties["_discount"],
                discountPercentage: item.properties["_discount"] * 100 / (item.properties["_originalPrice"] * item.properties["_quantity"])
              };
            }

            // if (item.properties["_tags"] != null && item.id != variant.id) {
            //   tagsList = item.properties["_tags"].split(" ");
            //   var exist = false;

            //   try {
            //     tagsList.forEach(element => {
            //       if (element == tag) {
            //         exist = true;
            //       }
            //     });
            //   } catch (error) {
            //   }

            //   if (exist == true) {
            //     item.properties["_discount"] = (totalFree - count) >= item.quantity ? (item.price * item.quantity) : (totalFree - count) * item.price;
            //     item.properties["_bonificacionId"] = "BONXMAT_" + variant.id;
            //     item.properties["_originalPrice"] = item.price;
            //     item.properties["_quantity"] = item.quantity;
            //     console.log(item)
            //     // changes.push({ 'id': item.key + "", 'quantity': item.quantity, 'properties': item.properties });
            //     count += (totalFree - count) >= item.quantity ? item.quantity : (totalFree - count);

            //     entities[functionName + "_" + variant.id] = {
            //       discountDef: variant.discountDef,
            //       variant: item,
            //       discount: item.properties["_discount"],
            //       discountPercentage: item.properties["_discount"] * 100 / (item.properties["_originalPrice"] * item.properties["_quantity"])
            //     };

            //   }
            // }

            if (count == totalFree) {
              break;
            }
          }

          if (count < totalFree) {
            message += ("Gratis: Tag: " + tag + " X (" + (totalFree - count) + ") </br>");
            entitiesBonifications.push({ type: "tag", qty: (totalFree - count), ref: tag });
          }
        }
      }
    }

  } catch (e) {
    result.message = e.message;
    result.applied = false;
    result.priceWithDiscount = result.basePrice;
  }

  return result;
};
functionsDef.push({ functionName: "BONXMAT", function: BONXMAT });

/* 
  Nivel: [SKUs] x cant -> Lleva 100% de descuento en SKU
  Descripción: MERCADEO PRODUCTO PROMOCIONAL POR CANTIDAD COMPRA (RANGOS).
  Parametros: {
        freeSKU: SKU gratis por cada "mulQty"
          mulQty: Cant multiplo por la cual se dara una ref de "freeSKU",
          tag: se busca dentro del carrito los para sumar la catidad multiplo de "mulQty",
          minDate: Fecha de inicio("31/11/2022"),
          maxDate: Fecha de fin("31/12/2022")
      }
  */
var BONXMATR = function (currentPrice, variant, parameters, cart) {
  var functionName = "BONXMATR";
  var temp = {
    freeSKU: parameters[0].trim(),
    mulQty: parameters[1].trim(),
    tag: parameters[2].trim(),
    cart: cart,
    minDate: parameters[3].trim(),
    maxDate: parameters[4].trim(),
  };

  parameters = temp;

  var result = {
    discountName: functionName,
    parameters: parameters,
    basePrice: currentPrice,
    priceWithDiscount: currentPrice,
    applied: false,
    message: ""
  };

  try {
    var minDate = moment(parameters.minDate, "DD/MM/YYYY");
    var maxDate = moment(parameters.maxDate, "DD/MM/YYYY");
    var currentDate = moment();
    var changes = [];

    //Limpiar descuentos 100% a items tag x con propiedad bonificacionId = BONXMAT_variantId
    for (i in parameters.cart.items) {
      var item = parameters.cart.items[i];

      if (item.properties && item.properties["_bonificacionId"] == functionName + "_" + variant.id) {
        item.properties["_discount"] = undefined;
        item.properties["_bonificacionId"] = undefined;
        item.properties["_originalPrice"] = undefined;
        item.properties["_quantity"] = undefined;

        changes.push({ 'id': item.key + "", 'quantity': item.quantity, 'properties': item.properties });

        entities[functionName + "_" + item.id] = {
          discountDef: variant.discountDef,
          variant: item,
          discount: 0,
          discountPercentage: 0
        };
      }
    }

    console.log(minDate.isSameOrBefore(currentDate) && maxDate.isAfter(currentDate));

    if (minDate.isSameOrBefore(currentDate) && maxDate.isAfter(currentDate)) {
      var qty = variant.quantity;
      var tag = parameters.tag;
      var sku = null;

      if (tag != null && tag != "") {

        for (i in parameters.cart.items) {
          var item = parameters.cart.items[i];

          if (item.properties["_tags"] != null && item.properties["_tags"].includes(tag) && item.id != variant.id && item.sku != parameters.freeSKU) {
            qty += item.quantity;
            console.log(item)
          }
          if (item.sku == parameters.freeSKU) {
            sku = JSON.parse(JSON.stringify(item));
          }
        }
      }

      if (qty >= parameters.mulQty) {

        var totalFree = Math.floor(qty / parameters.mulQty);

        if (sku == null) {
          message += ("Gratis: SKU: " + parameters.freeSKU + " X (" + totalFree + ") </br>");
          entitiesBonifications.push({ type: "sku", qty: totalFree, ref: parameters.freeSKU });
        }
        else {
          //actualiza SKU
          sku.properties["_discount"] = totalFree >= sku.quantity ? (sku.price * sku.quantity) : totalFree * sku.price;
          sku.properties["_bonificacionId"] = functionName + "_" + variant.id;
          sku.properties["_originalPrice"] = sku.price;
          sku.properties["_quantity"] = sku.quantity;
          console.log(sku);

          changes.push({ 'id': sku.key + "", 'quantity': sku.quantity, 'properties': sku.properties });

          entities[functionName + "_" + sku.id] = {
            discountDef: variant.discountDef,
            variant: sku,
            discount: sku.properties["_discount"],
            discountPercentage: sku.properties["_discount"] * 100 / (sku.properties["_originalPrice"] * sku.properties["_quantity"])
          };

          if (sku.quantity < totalFree) {
            message += ("Gratis: SKU: " + parameters.freeSKU + " X (" + (totalFree - sku.quantity) + ")</br>");
            entitiesBonifications.push({ type: "sku", qty: (totalFree - sku.quantity), ref: parameters.freeSKU });
          }
        }


      }
    }

  } catch (e) {
    result.message = e.message;
    result.applied = false;
    result.priceWithDiscount = result.basePrice;
  }

  return result;
};
functionsDef.push({ functionName: "BONXMATR", function: BONXMATR });

/* 
  Nivel: [SKUs] x $ -> Lleva 100% de descuento en SKU
  Descripción: BONIFICACION EN PRODUCTOS O PROMOCIONAL POR VALOR PEDIDO
  Parametros: {
        freeSKU: SKU gratis por cada "mulQty"
          total: Cant multiplo por la cual se dara una ref de "freeSKU",
          tag: se busca dentro del carrito los para sumar la catidad multiplo de "mulQty",
          minDate: Fecha de inicio("31/11/2022"),
          maxDate: Fecha de fin("31/12/2022")
      }
  */
var BONXVALP = function (currentPrice, variant, parameters, cart) {
  var functionName = "BONXVALP";
  var temp = {
    freeSKU: parameters[0].trim(),
    total: parameters[1].trim(),
    tag: null,
    cart: cart,
    minDate: parameters[2].trim(),
    maxDate: parameters[3].trim(),
  };

  parameters = temp;

  var result = {
    discountName: functionName,
    parameters: parameters,
    basePrice: currentPrice,
    priceWithDiscount: currentPrice,
    applied: false,
    message: ""
  };

  try {
    var minDate = moment(parameters.minDate, "DD/MM/YYYY");
    var maxDate = moment(parameters.maxDate, "DD/MM/YYYY");
    var currentDate = moment();
    var changes = [];

    //Limpiar descuentos 100% a items tag x con propiedad bonificacionId = BONXMAT_variantId
    for (i in parameters.cart.items) {
      var item = parameters.cart.items[i];

      if (item.properties && item.properties["_bonificacionId"] == functionName + "_" + variant.id) {
        item.properties["_discount"] = undefined;
        item.properties["_bonificacionId"] = undefined;
        item.properties["_originalPrice"] = undefined;
        item.properties["_quantity"] = undefined;

        changes.push({ 'id': item.key + "", 'quantity': item.quantity, 'properties': item.properties });

        entities[functionName + "_" + item.id] = {
          discountDef: variant.discountDef,
          variant: item,
          discount: 0,
          discountPercentage: 0
        };
      }
    }

    console.log(minDate.isSameOrBefore(currentDate) && maxDate.isAfter(currentDate));

    if (minDate.isSameOrBefore(currentDate) && maxDate.isAfter(currentDate)) {
      var total = variant.price * variant.quantity;
      var tag = parameters.tag;
      var sku = null;

      if (tag != null && tag != "") {
        for (i in parameters.cart.items) {
          var item = parameters.cart.items[i];

          if (item.properties["_tags"] != null && item.properties["_tags"].includes(tag) && item.id != variant.id && item.sku == parameters.freeSKU && item.sku != parameters.freeSKU) {
            total += item.price * item.quantity;;
            console.log(item)
          }
          if (item.sku == parameters.freeSKU) {
            sku = JSON.parse(JSON.stringify(item));
          }
        }
      }
      else {
        for (i in parameters.cart.items) {
          var item = parameters.cart.items[i];

          total += item.price * item.quantity;;
          console.log(item)

          if (item.sku == parameters.freeSKU) {
            sku = JSON.parse(JSON.stringify(item));
          }
        }
      }

      total = total / 100;

      if (total >= parseFloat(parameters.total)) {

        var totalFree = Math.floor(total / parameters.total);

        if (sku == null) {
          message += ("Gratis: SKU: " + parameters.freeSKU + " X (" + totalFree + ")</br>");
          entitiesBonifications.push({ type: "sku", qty: totalFree, ref: parameters.freeSKU });
        }
        else {
          //actualiza SKU
          sku.properties["_discount"] = totalFree >= sku.quantity ? (sku.price * sku.quantity) : totalFree * sku.price;
          sku.properties["_bonificacionId"] = functionName + "_" + variant.id;
          sku.properties["_originalPrice"] = sku.price;
          sku.properties["_quantity"] = sku.quantity;
          console.log(sku);

          changes.push({ 'id': sku.key + "", 'quantity': sku.quantity, 'properties': sku.properties });

          entities[functionName + "_" + sku.id] = {
            discountDef: variant.discountDef,
            variant: sku,
            discount: sku.properties["_discount"],
            discountPercentage: sku.properties["_discount"] * 100 / (sku.properties["_originalPrice"] * sku.properties["_quantity"])
          };

          if (sku.quantity < totalFree) {
            message += ("Gratis: SKU: " + parameters.freeSKU + " X (" + (totalFree - sku.quantity) + ")</br>");
            entitiesBonifications.push({ type: "sku", qty: (totalFree - sku.quantity), ref: parameters.freeSKU });
          }
        }
        0.
      }
    }

  } catch (e) {
    result.message = e.message;
    result.applied = false;
    result.priceWithDiscount = result.basePrice;
  }

  return result;
};
functionsDef.push({ functionName: "BONXVALP", function: BONXVALP });

/* 
  Nivel: Total Pedido x $ -> Lleva 100% de descuento en SKU
  Descripción: 
  Parametros: {
        freeSKU: SKU gratis por cada "mulQty"
          total: Cant multiplo por la cual se dara una ref de "freeSKU",
          minDate: Fecha de inicio("31/11/2022"),
          maxDate: Fecha de fin("31/12/2022")
      }
  */
var BONXVALPR = function (currentPrice, variant, parameters, cart) {
  var functionName = "BONXVALPR";
  var temp = {
    ranges: [],
    cart: cart,
    total: -1,
    minDate: parameters[0].trim(),
    maxDate: parameters[1].trim(),
  };
  for (var i = 2; i < parameters.length; i++) {
    temp.ranges.push(
      { freeSKU: parameters[i].trim(), total: parameters[++i].trim() }
    );
  }

  parameters = temp;

  var result = {
    discountName: functionName,
    parameters: parameters,
    basePrice: currentPrice,
    priceWithDiscount: currentPrice,
    applied: false,
    message: ""
  };

  try {
    var minDate = moment(parameters.minDate, "DD/MM/YYYY");
    var maxDate = moment(parameters.maxDate, "DD/MM/YYYY");
    var currentDate = moment();
    var changes = [];

    //Limpiar descuentos 100% a items tag x con propiedad bonificacionId = BONXMAT_variantId
    for (i in parameters.cart.items) {
      var item = parameters.cart.items[i];

      if (item.properties && item.properties["_bonificacionId"] == functionName + "_" + variant.id) {
        item.properties["_discount"] = undefined;
        item.properties["_bonificacionId"] = undefined;
        item.properties["_originalPrice"] = undefined;
        item.properties["_quantity"] = undefined;

        changes.push({ 'id': item.key + "", 'quantity': item.quantity, 'properties': item.properties });

        entities[functionName + "_" + item.id] = {
          discountDef: variant.discountDef,
          variant: item,
          discount: 0,
          discountPercentage: 0
        };
      }
    }

    console.log(minDate.isSameOrBefore(currentDate) && maxDate.isAfter(currentDate));

    if (minDate.isSameOrBefore(currentDate) && maxDate.isAfter(currentDate)) {
      var total = variant.price * variant.quantity;
      var sku = null;

      for (i in parameters.cart.items) {
        var item = parameters.cart.items[i];

        if (item.id != variant.id && item.sku != parameters.freeSKU) {
          total += item.price * item.quantity;;
          console.log(item)
        }
        if (item.sku == parameters.freeSKU) {
          sku = JSON.parse(JSON.stringify(item));
        }
      }

      total = total / 100;

      var ranges = parameters.ranges.sort((a, b) => ((a.total) > (b.total)) ? 1 : -1);

      for (i in ranges) {
        var range = ranges[i];

        if (total >= range.total) {
          parameters.total = range.total
        }
      }

      if (total >= parameters.total && parameters.total != -1) {

        var totalFree = Math.floor(total / parameters.total);

        if (sku == null) {
          message += ("Gratis: SKU: " + parameters.freeSKU + " X (" + totalFree + ")</br>");
          entitiesBonifications.push({ type: "sku", qty: totalFree, ref: parameters.freeSKU });
        }
        else {
          //actualiza SKU
          sku.properties["_discount"] = totalFree >= sku.quantity ? (sku.price * sku.quantity) : totalFree * sku.price;
          sku.properties["_bonificacionId"] = functionName + "_" + variant.id;
          sku.properties["_originalPrice"] = sku.price;
          sku.properties["_quantity"] = sku.quantity;
          console.log(sku);

          changes.push({ 'id': sku.key + "", 'quantity': sku.quantity, 'properties': sku.properties });

          entities[functionName + "_" + sku.id] = {
            discountDef: variant.discountDef,
            variant: sku,
            discount: sku.properties["_discount"],
            discountPercentage: sku.properties["_discount"] * 100 / (sku.properties["_originalPrice"] * sku.properties["_quantity"])
          };

          if (sku.quantity < totalFree) {
            message += ("Gratis: SKU: " + parameters.freeSKU + " X (" + (totalFree - sku.quantity) + ")</br>");
            entitiesBonifications.push({ type: "sku", qty: (totalFree - sku.quantity), ref: parameters.freeSKU });
          }
        }
      }
    }

  } catch (e) {
    result.message = e.message;
    result.applied = false;
    result.priceWithDiscount = result.basePrice;
  }

  return result;
};
functionsDef.push({ functionName: "BONXVALPR", function: BONXVALPR });

/* 
  Descripción: 
  Parametros:
  */
var KITS = function (currentPrice, variant, parameters) {
  var result = {
    discountName: "KITS",
    parameters: parameters,
    basePrice: currentPrice,
    priceWithDiscount: currentPrice,
    applied: false,
    message: ""
  };

  try {

  } catch (e) {
    result.message = e.message;
    result.applied = false;
    result.priceWithDiscount = result.basePrice;
  }

  return result;
};
functionsDef.push({ functionName: "KITS", function: KITS });

//Add functions
for (i in functionsDef) {
  var def = functionsDef[i];

  functions[def.functionName] = def.function;
}


//Utils
function SortByPriority(discounts) {
  try {
    discounts.sort((a, b) => (GetValuePriority(a.discountDef.priority) > GetValuePriority(b.discountDef.priority)) ? 1 : -1);
  }
  catch (e) { }

  return discounts;
}

function GetValuePriority(priority) {
  var result = 5;

  switch (priority) {
    case "Muy alta":
      result = 1;
      break;
    case "Alta":
      result = 2;
      break;
    case "Media":
      result = 3;
      break;
    case "Baja":
      result = 4;
      break;
    case "Muy baja":
      result = 5;
      break;
    default:
      result = 5;
  }

  return result;
}

function GetDiscount(price, percentage) {
  try {
    var discount = price * (percentage / 100);
  }
  catch (e) { }

  return discount;
};

function GetQueryParams() {
  qs = document.location.search;
  qs = qs.split('+').join(' ');

  var params = {},
    tokens,
    re = /[?&]?([^=]+)=([^&]*)/g;

  while (tokens = re.exec(qs)) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }

  return params;
};

function GetDiscParticipation(price, percentage, discountDef, variantWithDiscMap, cart, changesGenMap) {
  try {
    var discount = price * (percentage / 100);

    for (i in cart.items) {
      var item = cart.items[i];
      var linePrice = item.original_price * item.quantity;
      var oldItem = variantWithDiscMap[item.key];

      if (oldItem != null) {
        linePrice = oldItem.totalPrice - oldItem.discount
      }

      var participation = 1 / (price / linePrice);
      if (participation > 0) {
        item.properties["_discount"] = linePrice - (discount * participation);
        item.properties["_bonificacionId"] = discountDef.functionName + "_" + item.id;
        item.properties["_bonificationName"] = discountDef.functionName;
        item.properties["_bonificationDiscounts"] = discount * participation;
        item.properties["_originalPrice"] = linePrice;
        item.properties["_quantity"] = item.quantity;

        var entity = { 'id': item.key + "", 'quantity': item.quantity, 'properties': item.properties }

        if (changesGenMap[item.key] == null) {
          changesGenMap[item.key] = [];
          changesGenMap[item.key].push(entity);
        }
        else {
          changesGenMap[item.key].push(entity);
        }
      }
    }
  }
  catch (e) { }

  return changesGenMap;
};

async function GetBonificationProducts(entities) {

  var head = '<div id="shopify-section-search_recommedation_heading" class="shopify-section page_section_heading"><div class="page-head tc pr oh page_head_search_recommedation_heading"><div class="container pr z_100"><h1 class="tu mb__10 cw">Bonificaciones</h1></div></div><style data-shopify="">.page_head_search_recommedation_heading{padding: 50px 0}@media (min-width: 768px){.page_head_search_recommedation_heading{padding: 50px 0}}.page_head_search_recommedation_heading:before{background-color: #000;opacity: 0.54}.page_head_search_recommedation_heading .parallax-inner{background-repeat: no-repeat; background-size: cover; background-attachment: scroll; background-position: center center;}</style></div>';
  var data = "";

  for (i in entities) {
    var element = entities[i];
    var query = "";
    var descriptionHtml = element.type == "tag" ? "Colección: " : "SKU: ";

    descriptionHtml += element.ref;
    descriptionHtml += '<strong>(X' + element.qty + ')</strong> </span></div>';

    if (element.type == "tag") {
      query = "tag:" + element.ref;
    }
    else {
      query = +element.ref;
    }

    temp = await newSearch(query);

    if (data == "") {
      data = temp.replace("##DESCRIPTION##", descriptionHtml);
    }
    else {
      temp = temp.replace("##DESCRIPTION##", descriptionHtml);
      data = data.replace("##OTHER##", temp);
    }

  }
  console.log(data);
  data = head + data.replace("##OTHER##", "");

  ShowBonifications(data, descriptionHtml);
}

function ShowBonifications(data, descriptionHtml) {
  var body = $('body');

  var quickview_js = function (bl, dt, btn, ntid, href) {
    var html_hasClass = $('html').hasClass('hside_opened');
    var IsType2 = body.hasClass('type_quickview_2'),
      removalDelayTime = IsType2 ? 500 : 0,
      closeBtnInside = IsType2;

    $.magnificPopup.open({
      items: {
        src: '<div class="mfp-with-anim popup-quick-view" id="content_quickview">' + dt + '</div>', // can be a HTML string, jQuery_T4NT object, or CSS selector
        type: 'inline'
      },
      tClose: "txt_close",
      closeBtnInside: closeBtnInside,
      removalDelay: removalDelayTime, //delay removal by X to allow out-animation
      callbacks: {
        beforeOpen: function () {
          this.st.mainClass = 'mfp-move-horizontal popup_qv_t4s';
        },
        open: function () {
          if (html_hasClass) {
            $('.hside_opened').removeClass('hside_opened');
            $('.pside_opened').removeClass('pside_opened');
          }
          //btn.addClass('pp_t4_opended');
          var el = $('.nt_carousel_qv'), option = el.attr("data-flickityt4s-js") || '{}';
          //console.log(option)
          el.flickityt4s(JSON.parse(option));

          body.addClass('open_ntqv');
          geckoShopify.ATC_animation('#callBackVariant_qv .single_add_to_cart_button');
          geckoShopify.InitCountdown_pr('#nt_countdow_qv');
          geckoShopify.wishlistUpdate(0, ntid);
          geckoShopify.compareUpdate(0, ntid);
          // var qty_mess = $('#nt_stock_qv').data('st');
          // if (qty_mess == 2 || qty_mess == 3) {geckoShopify.progressbar('#nt_stock_qv')}
          var txt_stock = '#nt_stock_qv',
            $nt_stock = $(txt_stock),
            qty_cur = $nt_stock.data('cur'),
            qty_mess = $nt_stock.data('st'),
            ck_inventory = $nt_stock.data('qty');
          if ((qty_mess == 1 || qty_mess == 3) && qty_cur < ck_inventory && qty_cur > 0) {
            geckoShopify.progressbar(txt_stock, qty_cur);
          } else if (qty_mess != 1) {
            geckoShopify.progressbar(txt_stock);
          }
          geckoShopify.delivery_order('#delivery_qv');
          geckoShopify.real_time('#counter_qv');
          geckoShopify.flashSold('#sold_qv');
          //geckoShopify.intThe4IP('#ship_qv');
          body.trigger('refresh_currency');

          if (typeof addthis !== 'undefined') { addthis.layers.refresh() }

          if (sp_nt_storage && bl) {
            sessionStorage.setItem('qv' + ntid, dt)
          }

          $('#content_quickview .entry-title a, #content_quickview .detail_link').attr("href", href);
          //btn.removeClass('loading');

          geckoShopify.DropdownPicker();
          geckoShopify.review();

          if ($('#content_quickview .buy_qv_true').length > 0) {
            Shopify.PaymentButton.init();
          }
          if ($('#store_availability_qv').attr('data-has-only-default-variant') === 'true') {
            geckoShopify._updateStoreAvailabilityContent($('#store_availability_qv'), true, $('#store_availability_qv').attr('data-vid'));
          }
          $('#content_quickview .lazypreloadt4s.nt_pre_img').addClass('lazyloadt4s');

          if (!$('#ProductJson-template_qv').html()) {
            return;
          }

          var productJson = JSON.parse($('#ProductJson-template_qv').html()),
            incomingJson = JSON.parse($('#ProductJson-incoming_qv').html()),
            IdSelect = '#product-select_qv', NtId = '#nt_select_qv_', selector = '#cart-form_qv', callBackVariant = '#callBackVariant_qv', prefix = '_qv',
            i, variant, Arr_MD = [];

          productJson.ck_so_un = incomingJson.ck_so_un;
          productJson.ntsoldout = incomingJson.ntsoldout;
          productJson.unvariants = incomingJson.unvariants;
          productJson.remove_soldout = incomingJson.remove_soldout;
          productJson.size_avai = incomingJson.size_avai;
          productJson.tt_size_avai = incomingJson.tt_size_avai;

          for (i in incomingJson.variants) {
            variant = incomingJson.variants[i];
            productJson.variants[i].incoming = variant.incoming;
            productJson.variants[i].next_incoming_date = variant.next_incoming_date;
            productJson.variants[i].inventory_quantity = variant.inventory_quantity;
            Arr_MD.push(variant.mdid);
          }
          geckoShopify.Ntproduct_switch('.variations_form_qv', Arr_MD, productJson, selector, IdSelect, NtId, callBackVariant, prefix);
          if (nt_settings.pr_curent !== "1" || $('#cart-form_qv .is-selected-nt').length > 0) {
            $('#nt_select_qv_1 .is-selected-nt, #nt_select_qv_2 .is-selected-nt').addClass('is-selected').removeClass('is-selected-nt');
            $('#nt_select_qv_0 .is-selected-nt').click().removeClass('is-selected-nt');

            if (!use_vimg) return;
            $('#nt_select_qv_1 .is-selected,#nt_select_qv_2 .is-selected').removeClass('is-selected').click();
          }

          $(".container.container_cat.cat_default.pop_default.mb__80").removeClass("mb__80")
          $(".container.container_cat.cat_default.pop_default.mb__80").addClass("mb__10")
        },
        beforeClose: function () {
          if (html_hasClass) {
            $('html').addClass('hside_opened');
            body.addClass('pside_opened');
          }
          if ($('.store_availabilities_modal.act_opened').length > 0) {
            $('.store_availabilities_modal .close_pp').trigger('click');
          }



        },
        close: function () {
          $('#content_quickview').empty();
          body.trigger('refresh_hreft4');
          //btn.removeClass('pp_t4_opended');
          body.removeClass('open_ntqv');
          geckoShopify.DropdownPicker();
        },
        afterClose: function () {
          if (!$('.act_opened').length) {
            $('.hside_opened').removeClass('hside_opened');
            $('.pside_opened').removeClass('pside_opened');
          }
        }
      },
    });
  };

  if ($.magnificPopup.instance.isOpen) {
    $.magnificPopup.close();
    setTimeout(function () { quickview_js(true, data, btn, ntid, href); }, $.magnificPopup.instance.st.removalDelay + 10);
  } else {
    quickview_js(true, data);
  }
}

const newSearch = (query) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'search?options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&q=' + query + '*&type=product&resources[limit]=4&view=recommedations',
      success: function (data) {
        resolve(data);
      },
      complete: function (x) {
        console.log(x);
      }
    });
  })
};

//Execute functions
function GetFinalPrice(entities, cart) {
  entities = entities;
  var sortEntities = [];
  var sortEntitiesGen = [];
  var discountsByVariant = [];
  var data = [];
  var changes = [];
  var changesGenMap = [];
  var variantWithDiscMap = [];
  var totalDiscounts = 0;

  for (i in entities) {
    var entity = entities[i];

    entity.bonificationId = i;
    sortEntities.push(entity);
  }
  for (i in generalDiscount) {
    var entity = generalDiscount[i];

    entity.bonificationId = i;
    sortEntitiesGen.push(entity);
  }

  sortEntities = SortByPriority(sortEntities);
  sortEntitiesGen = SortByPriority(sortEntitiesGen);

  for (i in sortEntities) {
    var entity = sortEntities[i];

    if (discountsByVariant[entity.variant.key] == null) {
      discountsByVariant[entity.variant.key] = [];
      discountsByVariant[entity.variant.key].push(entity);
    }
    else {
      discountsByVariant[entity.variant.key].push(entity);
    }
  }

  for (x in discountsByVariant) {
    var discounts = discountsByVariant[x];
    var variant = discounts[0].variant;
    var currentPrice = variant.price * variant.quantity;
    var bonificationId = [];
    var bonificationName = [];
    var bonificationDiscounts = [];
    var result = {
      price: variant.price * variant.quantity,
      priceWithDiscount: variant.price * variant.quantity,
      discounts: [],
      discountsNotApplied: []
    };

    var flag = false;

    for (i in discounts) {
      if (flag == false) {
        var entity = discounts[i];
        var discount = entity.discountDef;
        var variantDiscount = 0;

        if (entity.discountPercentage != null && entity.discountPercentage != "" && entity.discountPercentage > 0) {
          if (discount.isCumulative == "false") {
            if (i == "0") {
              variantDiscount = GetDiscount(currentPrice, entity.discountPercentage);

              bonificationId.push(entity.bonificationId);
              bonificationDiscounts.push(variantDiscount);
              bonificationName.push(discount.functionName);
              result.discounts.push(entity);
              flag = true;
            }
            else {
              result.discountsNotApplied.push(entity);
            }
          }
          else {
            variantDiscount = GetDiscount(currentPrice, entity.discountPercentage);

            bonificationId.push(entity.bonificationId);
            bonificationDiscounts.push(variantDiscount);
            bonificationName.push(discount.functionName);
            result.discounts.push(entity);
          }
        }

        currentPrice = currentPrice - variantDiscount;
        result.priceWithDiscount = currentPrice;
      }
    }

    var withDiscount = (variant.price * variant.quantity) > currentPrice;
    variant.properties["_discount"] = withDiscount ? (variant.price * variant.quantity) - currentPrice : undefined;
    variant.properties["_bonificacionId"] = withDiscount ? bonificationId.join() : undefined;
    variant.properties["_bonificationName"] = withDiscount ? bonificationName.join() : undefined;
    variant.properties["_bonificationDiscounts"] = withDiscount ? bonificationDiscounts.join() : undefined;
    variant.properties["_originalPrice"] = withDiscount ? (variant.price * variant.quantity) : undefined;
    variant.properties["_quantity"] = withDiscount ? variant.quantity : undefined;
    console.log(variant);

    changes.push({ 'id': variant.key + "", 'quantity': variant.quantity, 'properties': variant.properties });

    if (withDiscount) {
      totalDiscounts += variant.properties["_discount"];
      variantWithDiscMap[variant.key] = { 'quantity': variant.quantity, totalPrice: (variant.price * variant.quantity), discount: variant.properties["_discount"] };
    }

    data.push(result);
  }

  var totalOrder = cart.original_total_price - totalDiscounts;

  for (i in sortEntitiesGen) {
    var entity = sortEntitiesGen[i];
    var discount = entity.discountDef;

    if (entity.discountPercentage != null && entity.discountPercentage != "" && entity.discountPercentage > 0) {
      if (discount.isCumulative == false) {
        if (i == "0") {
          changesGenMap = GetDiscParticipation(totalOrder, entity.discountPercentage, discount, variantWithDiscMap, JSON.parse(JSON.stringify(cart)), changesGenMap);
          totalOrder = totalOrder - GetDiscount(totalOrder, entity.discountPercentage);

          break;
        }
        else {
          result.discountsNotApplied.push(entity);
        }
      }
      else {
        changesGenMap = GetDiscParticipation(totalOrder, entity.discountPercentage, discount, variantWithDiscMap, JSON.parse(JSON.stringify(cart)), changesGenMap);
        totalOrder = totalOrder - GetDiscount(totalOrder, entity.discountPercentage);
      }
    }
  }

  for (i in changes) {
    var entity = changes[i];

    if (changesGenMap[entity.id] != null) {
      for (j in changesGenMap[entity.id]) {
        var generalDisc = changesGenMap[entity.id][j];

        entity.properties["_discount"] = entity.properties["_discount"] ? entity.properties["_discount"] + generalDisc.properties["_discount"] : generalDisc.properties["_discount"];
        entity.properties["_bonificacionId"] = entity.properties["_bonificacionId"] ? entity.properties["_bonificacionId"] + "," + generalDisc.properties["_bonificacionId"] : generalDisc.properties["_bonificacionId"];
        entity.properties["_bonificationName"] = entity.properties["_bonificationName"] ? entity.properties["_bonificationName"] + "," + generalDisc.properties["_bonificationName"] : generalDisc.properties["_bonificationName"];
        entity.properties["_bonificationDiscounts"] = entity.properties["_bonificationDiscounts"] ? entity.properties["_bonificationDiscounts"] + "," + generalDisc.properties["_bonificationDiscounts"] : generalDisc.properties["_bonificationDiscounts"];
      }

      changesGenMap[entity.id] = undefined;
    }
  }

  for (i in changesGenMap) {
    var entities = changesGenMap[i];

    for (j in entities) {
      var entity = entities[j];

      changes.push(entity);
    }
  }


  console.log(data);
  console.log(changes);

  updateCart(changes);

  return data;
}

function SetDiscount() {
  entities = [];
  message = "";

  jQuery.getJSON('/cart.js', function (cart) {
    console.log((cart));

    for (i in cart.items) {
      console.log(cart.items[i]);
      var item = cart.items[i];

      if (item.properties && item.properties["_bonificacionId"] != null && item.properties["_discount"] != null) {
        var bonificacionList = item.properties["_bonificacionId"].split(",");

        for (j in bonificacionList) {
          var bonificacionId = bonificacionList[j].trim();

          entities[bonificacionId] = {
            discountDef: {
              isCumulative: "true",
              priority: "Muy baja",
              functionName: "",
              parameters: ""
            },
            variant: item,
            discount: 0,
            discountPercentage: 0
          };
        }
      }
    }

    //<------Product discounts------>
    for (i in cart.items) {
      console.log(cart.items[i]);
      var item = cart.items[i];

      if (item.properties != null && item.properties["_descuento_escalonado"] != null && item.properties["_descuento_escalonado"] != "") {
        var parameters = (item.properties["_parametros_descuento"]).split(",");
        var discount = ({
          isCumulative: item.properties["_es_acumulativo"],
          priority: item.properties["_prioridad_descuento"],
          functionName: item.properties["_descuento_escalonado"],
          parameters: parameters
        });

        item.discountDef = discount;

        var response = functions[discount.functionName](item.price, item, discount.parameters, cart);
      }
      if (item.properties != null && item.properties["_descuento_escalonado_2"] != null && item.properties["_descuento_escalonado_2"] != "") {
        var parameters = (item.properties["_parametros_descuento_2"]).split(",");
        var discount = ({
          isCumulative: item.properties["_es_acumulativo_2"],
          priority: item.properties["_prioridad_descuento_2"],
          functionName: item.properties["_descuento_escalonado_2"],
          parameters: parameters
        });

        item.discountDef = discount;

        var response = functions[discount.functionName](item.price, item, discount.parameters, cart);
      }
      if (item.properties != null && item.properties["_descuento_escalonado_3"] != null && item.properties["_descuento_escalonado_3"] != "") {
        var parameters = (item.properties["_parametros_descuento_3"]).split(",");
        var discount = ({
          isCumulative: item.properties["_es_acumulativo_3"],
          priority: item.properties["_prioridad_descuento_3"],
          functionName: item.properties["_descuento_escalonado_3"],
          parameters: parameters
        });

        item.discountDef = discount;

        var response = functions[discount.functionName](item.price, item, discount.parameters, cart);
      }
      if (item.properties != null && item.properties["_descuento_escalonado_4"] != null && item.properties["_descuento_escalonado_4"] != "") {
        var parameters = (item.properties["_parametros_descuento_4"]).split(",");
        var discount = ({
          isCumulative: item.properties["_es_acumulativo_4"],
          priority: item.properties["_prioridad_descuento_4"],
          functionName: item.properties["_descuento_escalonado_4"],
          parameters: parameters
        });

        item.discountDef = discount;

        var response = functions[discount.functionName](item.price, item, discount.parameters, cart);
      }
      if (item.properties != null && item.properties["_descuento_escalonado_5"] != null && item.properties["_descuento_escalonado_5"] != "") {
        var parameters = (item.properties["_parametros_descuento_5"]).split(",");
        var discount = ({
          isCumulative: item.properties["_es_acumulativo_5"],
          priority: item.properties["_prioridad_descuento_5"],
          functionName: item.properties["_descuento_escalonado_5"],
          parameters: parameters
        });

        item.discountDef = discount;

        var response = functions[discount.functionName](item.price, item, discount.parameters, cart);
      }
    }

    //<------Customer discount------>
    var customer_parametros_descuento = $("#customer_parametros_descuento").val();
    var customer_descuento_escalonado = $("#customer_descuento_escalonado").val();
    var customer_es_acumulativo = $("#customer_descuento_escalonado").val();
    var customer_prioridad_descuento = $("#customer_prioridad_descuento").val();
    // discount_2
    var customer_parametros_descuento_2 = $("#customer_parametros_descuento_2").val();
    var customer_descuento_escalonado_2 = $("#customer_descuento_escalonado_2").val();
    var customer_es_acumulativo_2 = $("#customer_descuento_escalonado_2").val();
    var customer_prioridad_descuento_2 = $("#customer_prioridad_descuento_2").val();
    // discount_3
    var customer_parametros_descuento_3 = $("#customer_parametros_descuento_3").val();
    var customer_descuento_escalonado_3 = $("#customer_descuento_escalonado_3").val();
    var customer_es_acumulativo_3 = $("#customer_descuento_escalonado_3").val();
    var customer_prioridad_descuento_3 = $("#customer_prioridad_descuento_3").val();
    // discount_4
    var customer_parametros_descuento_4 = $("#customer_parametros_descuento_4").val();
    var customer_descuento_escalonado_4 = $("#customer_descuento_escalonado_4").val();
    var customer_es_acumulativo_4 = $("#customer_descuento_escalonado_4").val();
    var customer_prioridad_descuento_4 = $("#customer_prioridad_descuento_4").val();
    // discount_5
    var customer_parametros_descuento_5 = $("#customer_parametros_descuento_5").val();
    var customer_descuento_escalonado_5 = $("#customer_descuento_escalonado_5").val();
    var customer_es_acumulativo_5 = $("#customer_descuento_escalonado_5").val();
    var customer_prioridad_descuento_5 = $("#customer_prioridad_descuento_5").val();

    if (customer_parametros_descuento != "" && customer_descuento_escalonado != "") {
      var discounts = [];
      var parameters = customer_parametros_descuento.split(",");
      var item = {
        id: "1",
        price: 0,
        quantity: 0
      };
      var discount = ({
        isCumulative: customer_es_acumulativo,
        priority: customer_prioridad_descuento,
        functionName: customer_descuento_escalonado,
        parameters: parameters
      });

      item.discountDef = discount;

      var response = functions[discount.functionName](item.price, item, discount.parameters, cart);
    }
    if (customer_parametros_descuento_2 != "" && customer_descuento_escalonado_2 != "") {
      var discounts = [];
      var parameters = customer_parametros_descuento_2.split(",");
      var item = {
        id: "1",
        price: 0,
        quantity: 0
      };
      var discount = ({
        isCumulative: customer_es_acumulativo_2,
        priority: customer_prioridad_descuento_2,
        functionName: customer_descuento_escalonado_2,
        parameters: parameters
      });

      item.discountDef = discount;

      var response = functions[discount.functionName](item.price, item, discount.parameters, cart);
    }
    if (customer_parametros_descuento_3 != "" && customer_descuento_escalonado_3 != "") {
      var discounts = [];
      var parameters = customer_parametros_descuento_3.split(",");
      var item = {
        id: "1",
        price: 0,
        quantity: 0
      };
      var discount = ({
        isCumulative: customer_es_acumulativo_3,
        priority: customer_prioridad_descuento_3,
        functionName: customer_descuento_escalonado_3,
        parameters: parameters
      });

      item.discountDef = discount;

      var response = functions[discount.functionName](item.price, item, discount.parameters, cart);
    }
    if (customer_parametros_descuento_4 != "" && customer_descuento_escalonado_4 != "") {
      var discounts = [];
      var parameters = customer_parametros_descuento_4.split(",");
      var item = {
        id: "1",
        price: 0,
        quantity: 0
      };
      var discount = ({
        isCumulative: customer_es_acumulativo_4,
        priority: customer_prioridad_descuento_4,
        functionName: customer_descuento_escalonado_4,
        parameters: parameters
      });

      item.discountDef = discount;

      var response = functions[discount.functionName](item.price, item, discount.parameters, cart);
    }
    if (customer_parametros_descuento_5 != "" && customer_descuento_escalonado_5 != "") {
      var discounts = [];
      var parameters = customer_parametros_descuento_5.split(",");
      var item = {
        id: "1",
        price: 0,
        quantity: 0
      };
      var discount = ({
        isCumulative: customer_es_acumulativo_5,
        priority: customer_prioridad_descuento_5,
        functionName: customer_descuento_escalonado_5,
        parameters: parameters
      });

      item.discountDef = discount;

      var response = functions[discount.functionName](item.price, item, discount.parameters, cart);
    }

    //<------Shop discounts------->
    var shopDiscounts = [];
    var item = {
      id: "0",
      price: 0,
      quantity: 0
    };

    for (var i = 1; i <= 5; i++) {
      var shop_parametros_descuento = $("#shop_parametros_descuento_" + i).val();
      var shop_descuento_escalonado = $("#shop_descuento_escalonado_" + i).val();
      var shop_es_acumulativo = $("#shop_es_acumulativo_" + i).val();
      var shop_prioridad_descuento = $("#shop_prioridad_descuento_" + i).val();

      if (shop_parametros_descuento != null) {
        var parameters = shop_parametros_descuento.split(",");
        var discount = ({
          isCumulative: shop_es_acumulativo,
          priority: shop_prioridad_descuento,
          functionName: shop_descuento_escalonado,
          parameters: parameters
        });

        item.discountDef = discount;

        var response = functions[discount.functionName](item.price, item, discount.parameters, cart);
      }
    }

    if (entitiesBonifications.length > 0) {
      window.localStorage.setItem("message", message);
      window.localStorage.setItem("bonifications", JSON.stringify(entitiesBonifications));
    }
    else {
      window.localStorage.removeItem("message");
      window.localStorage.removeItem("bonifications");
    }

    GetFinalPrice(entities, cart);

    setTimeout(function () {
      window.location.href = "/cart?noUpdate=true";
    }, 1000);
  });
}

function InitTieredDiscount() {
  var parameters = GetQueryParams();
  console.log("...");

  if (parameters.noUpdate == null) {
    SetDiscount();
  }
  else {
    var bonificacions = window.localStorage.getItem("bonifications");

    if (bonificacions != null) {
      bonificacions = JSON.parse(bonificacions);

      if (bonificacions.length > 0) {
        GetBonificationProducts(bonificacions);
      }
    }
  }
}

async function updateCart(items) {
  for (i in items) {
    var item = items[i];
    var response = await changeItem(item);

    try {
      var id = item.id.split(":")[0];

      if (item.properties != null && !(item.properties["_discount"] == "" || item.properties["_discount"] == null)) {
        var price = geckoShopify.formatMoney(item.properties["_originalPrice"] * item.properties["_quantity"] - item.properties["_discount"]);
        var price_unit = geckoShopify.formatMoney((item.properties["_originalPrice"] * item.properties["_quantity"] - item.properties["_discount"]) / item.properties["_quantity"]);

        //  $("."+ id+"_withoutTiredDiscount").hide();        
        // $("."+ id+"_withTiredDiscount").show();
        //$("."+ id+"_tiredPrice").html(price);        
        //$("."+ id+"_tiredPrice_unit").html(price_unit);

        console.log("show");
      }
      else {
        //$("."+ id+"_withoutTiredDiscount").show();        
        //$("."+ id+"_withTiredDiscount").hide();

        console.log("hide");
      }
      console.log("." + id + "_withTiredDiscount")
    } catch {
    }

    console.log(response);
  };
}

const changeItem = (item) => {
  return new Promise((resolve, reject) => {
    fetch("/cart/change.json", {
      method: 'POST',
      body: JSON.stringify(item), // data can be `string` or {object}!
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => resolve(item))
      .catch(error => resolve(item))
      .then(response => resolve(item));
  })
};